import * as React from 'react';
import { FC } from 'react';

import { use$ } from '@legendapp/state/react';
import { MagnifierMinus, MagnifierPlus } from '@volkswagen-onehub/icons-core';
import styled, { css } from 'styled-components';

import { onZoom } from './utils/on-zoom';

import { TrackingEventName, ZoomActionTypes } from '../../store/stores/tracking/types';

import { interiorStore, zoomStore } from '../../store';
import { trackingStore } from '../../store/stores/tracking-store';
import { testId } from '../../test-utils/constants';
import { ActionWrapperBackgroundMixin } from '../action-wrapper-background.mixin';
import SphereButton from './sphere-control-button';

type ZoomDirection = 1 | -1;

const ZoomControls: FC = () => {
	const track = trackingStore.track;

	const zoomLimit = use$(zoomStore.zoomLimit);
	const isZoomed = use$(zoomStore.isZoomed);
	const isHidden = use$(interiorStore.isHidden);

	const handleZoomClick = (direction: ZoomDirection) => {
		// Track first and ask questions later
		track(TrackingEventName.VISUALIZER_VEHICLE_ZOOM, {
			contentId: ZoomActionTypes.UI_INTERACTION
		});

		onZoom(direction);
	};

	return (
		<Wrapper data-testid={testId('Zoom_Controls_Wrapper_Interior')} $isHidden={isHidden}>
			<StyledZoomControls data-testid={testId('Zoom_Controls_Wrapper')}>
				<SphereButton
					ariaLabel="zoomIn"
					onClick={() => handleZoomClick(1)}
					icon={<MagnifierPlus aria-hidden />}
					testId={testId('Zoom_In')}
					disabled={zoomLimit === 1}
				/>
				<SphereButton
					ariaLabel="zoomOut"
					onClick={() => handleZoomClick(-1)}
					icon={<MagnifierMinus aria-hidden />}
					testId={testId('Zoom_Out')}
					disabled={!isZoomed}
				/>
			</StyledZoomControls>
		</Wrapper>
	);
};

const Wrapper = styled.div<{ $isHidden?: boolean }>`
	position: relative;

	grid-row: 11;
	grid-column: 24;

	transition: opacity 0.3s ease;
	opacity: ${({ $isHidden }) => ($isHidden ? '0' : '1')};

	margin-right: ${props => props.theme.size.static200};
	margin-left: ${props => props.theme.size.static200};
	border-radius: ${props => props.theme.size.static150};

	flex-direction: column;

	${ActionWrapperBackgroundMixin()}
	${({ theme }) =>
		theme.variant === 'v26' &&
		css`
			display: flex;
			align-items: center;
			justify-content: center;
			width: 40px;
			height: 72px;
			margin-right: ${theme.size.static300};
			margin-left: ${theme.size.static300};
			border-radius: 20px;
			background: #1b2236;
			backdrop-filter: none;
			overflow: hidden;
		`}
`;

const StyledZoomControls = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.size.static150};
`;

export default ZoomControls;
